import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';
import { SmallButton } from '../../styles';

type InviteConfirmationDialogProps = {
  title: string;
  description: string;
  confirmButtonText: string;
  handleClose: () => void;
  isOpen: boolean;
  onConfirm: Function;
};

export const InviteConfirmationDialog = ({
  title,
  description,
  confirmButtonText,
  onConfirm,
  handleClose,
  isOpen,
}: InviteConfirmationDialogProps) => {
  return (
    <Dialog open={!!isOpen} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ fontSize: '1.4rem', color: 'primary.main' }}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ fontSize: '1.3rem' }}>
        <SmallButton hideBorder onClick={handleClose}>
          Cancel
        </SmallButton>
        <SmallButton
          contained
          sx={{
            backgroundColor: abyssColors.success[600],
            '&:hover': { backgroundColor: abyssColors.success[700] },
          }}
          onClick={() => {
            onConfirm();
            handleClose();
          }}
        >
          {confirmButtonText}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
};
